import { useContext } from 'react'
import { colorModeContext, IColorModeContext } from '../contexts/colorModeContext/colorModeContext'

const useThemeSetting = () => {
    return useContext(colorModeContext) as IColorModeContext
}

export default useThemeSetting